export const LIST_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const LIST_PAGE_SIZE_DEFAULT = 10;

/**
 * Coerce a saved/raw page size to an allowed option, or null if invalid.
 * @param {unknown} value
 * @param {number[]} [allowed]=LIST_PAGE_SIZE_OPTIONS
 * @returns {number|null}
 */
export function normalizePageSize(value, allowed = LIST_PAGE_SIZE_OPTIONS) {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  const size = Math.trunc(n);
  const options = Array.isArray(allowed) && allowed.length > 0 ? allowed : LIST_PAGE_SIZE_OPTIONS;
  return options.includes(size) ? size : null;
}

/**
 * @param {number} page 1-based
 * @param {number} totalPages
 * @returns {number}
 */
export function clampPage(page, totalPages) {
  const maxPage = Math.max(1, totalPages);
  const n = Number(page);
  if (!Number.isFinite(n)) return 1;
  return Math.min(Math.max(1, Math.trunc(n)), maxPage);
}

/**
 * @param {number} totalCount
 * @param {number} page 1-based
 * @param {number} pageSize
 */
export function getPaginationMeta(totalCount, page, pageSize) {
  const safeSize = Math.max(1, pageSize);
  const totalPages = totalCount === 0 ? 1 : Math.ceil(totalCount / safeSize);
  const safePage = clampPage(page, totalPages);
  const startIndex = (safePage - 1) * safeSize;
  const endIndex = Math.min(startIndex + safeSize, totalCount);
  return {
    totalPages,
    safePage,
    startIndex,
    endIndex,
    rangeStart: totalCount === 0 ? 0 : startIndex + 1,
    rangeEnd: endIndex,
  };
}

/**
 * @param {unknown[]} items
 * @param {number} page 1-based
 * @param {number} pageSize
 */
export function sliceItemsForPage(items, page, pageSize) {
  const meta = getPaginationMeta(items.length, page, pageSize);
  return {
    ...meta,
    items: items.slice(meta.startIndex, meta.endIndex),
  };
}

/**
 * @param {number} n
 */
export function formatPaginationCount(n) {
  return Number(n).toLocaleString();
}
